import { defineMessages } from "react-intl";

const FOOTER = "footer";

const footerMessages = defineMessages({
  ebscoCopyright: {
    id: `${FOOTER}.ebsco-copyright`,
    defaultMessage:
      "Software © {year} EBSCO Industries, LLC. All rights reserved."
  },
  privacyPolicy: {
    id: `${FOOTER}.privacy-policy`,
    defaultMessage: "Privacy policy"
  },
  termsOfUse: {
    id: `${FOOTER}.terms-of-use`,
    defaultMessage: "Terms of use"
  },
  manageMyCookies: {
    id: `${FOOTER}.manage-my-cookies`,
    defaultMessage: "Manage my cookies"
  }
});

export default footerMessages;
